/*
 * Copyright (C) 2023 DV Bern AG, Switzerland
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    inject
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthServiceRS} from '../../../authentication/service/AuthServiceRS.rest';
import {TSRole} from '../../../models/enums/TSRole';
import {TSVerfuegungZeitabschnittZahlungsstatus} from '../../../models/enums/TSVerfuegungZeitabschnittZahlungsstatus';
import {TSZahlungsstatusIconLabel} from './TSZahlungsstatusIconLabel';

@Component({
    selector: 'dv-zahlungsstatus-icon',
    templateUrl: './zahlungsstatus-icon.component.html',
    styleUrls: ['./zahlungsstatus-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ZahlungsstatusIconComponent implements OnInit {
    private readonly translate = inject(TranslateService);
    private readonly authService = inject(AuthServiceRS);

    @Input()
    public zahlungsstatus: TSVerfuegungZeitabschnittZahlungsstatus;

    @Input()
    public isBetreuungGueltig: boolean;
    public iconLabel: TSZahlungsstatusIconLabel;

    public ngOnInit(): void {
        this.iconLabel = new TSZahlungsstatusIconLabel(
            this.translate,
            this.zahlungsstatus,
            this.isBetreuungGueltig
        );
    }

    public getTitle(): string {
        let title = this.iconLabel.tooltipLabel;
        if (this.authService.isRole(TSRole.SUPER_ADMIN)) {
            title += ` (Superadmin: ${this.zahlungsstatus})`;
        }
        return title;
    }
}
